import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1325caf0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "feedback-region",
  "aria-live": "polite",
  "aria-label": "全局消息"
};
const _hoisted_2 = ["role"];
const _hoisted_3 = {
  class: "message-icon"
};
const _hoisted_4 = {
  class: "message-copy"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onKeydown"];
const _hoisted_8 = {
  class: "confirm-copy"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "confirm-kicker"
}, "ACTION REQUIRED", -1));
const _hoisted_10 = {
  id: "global-confirm-description"
};
const _hoisted_11 = {
  class: "confirm-actions"
};
import { computed, nextTick, onBeforeUnmount, ref, watch } from "vue";
import { CircleCheckFilled, Close, InfoFilled, QuestionFilled, WarningFilled } from "@element-plus/icons-vue";
import feedback, { feedbackState } from "@/services/feedback";
const confirmTitleId = "global-confirm-title";
export default {
  __name: 'AppFeedback',
  setup(__props) {
    const cancelButtonRef = ref(null);
    const confirmCardRef = ref(null);
    let previousFocus = null;
    const keepConfirmFocus = event => {
      if (feedbackState.confirm && confirmCardRef.value && !confirmCardRef.value.contains(event.target)) cancelButtonRef.value?.focus();
    };
    const trapConfirmFocus = event => {
      const buttons = [...(confirmCardRef.value?.querySelectorAll('button:not([disabled])') || [])];
      const first = buttons[0];
      const last = buttons[buttons.length - 1];
      if (!first) {
        event.preventDefault();
        confirmCardRef.value?.focus();
        return;
      }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === confirmCardRef.value)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    const iconMap = {
      success: CircleCheckFilled,
      warning: WarningFilled,
      error: WarningFilled,
      info: InfoFilled
    };
    const confirmIcon = computed(() => feedbackState.confirm?.tone === "danger" || feedbackState.confirm?.tone === "error" ? WarningFilled : QuestionFilled);
    const closeFromBackdrop = () => {
      if (feedbackState.confirm?.closeOnBackdrop) feedback.resolveConfirm(false);
    };
    const closeFromKeyboard = () => {
      if (feedbackState.confirm) feedback.resolveConfirm(false);
    };
    watch(() => feedbackState.confirm, async (confirm, previous) => {
      if (confirm) {
        if (!previous) previousFocus = document.activeElement;
        await nextTick();
        if (feedbackState.confirm !== confirm) return;
        document.addEventListener("focusin", keepConfirmFocus);
        cancelButtonRef.value?.focus();
      } else {
        document.removeEventListener("focusin", keepConfirmFocus);
        await nextTick();
        if (!feedbackState.confirm && previousFocus?.isConnected) previousFocus.focus();
      }
    });
    onBeforeUnmount(() => document.removeEventListener("focusin", keepConfirmFocus));
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_TransitionGroup, {
        name: "feedback-item",
        tag: "div",
        class: "message-stack"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feedbackState).messages, item => {
          return _openBlock(), _createElementBlock("article", {
            key: item.id,
            class: _normalizeClass(["feedback-message", item.type]),
            role: item.type === 'error' ? 'alert' : 'status'
          }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(iconMap[item.type] || _unref(InfoFilled))))]),
            _: 2
          }, 1024)]), _createElementVNode("div", _hoisted_4, [item.title ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), _createElementVNode("p", null, _toDisplayString(item.message), 1)]), _createElementVNode("button", {
            type: "button",
            "aria-label": "关闭消息",
            onClick: $event => _unref(feedback).close(item.id)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Close))]),
            _: 1
          })], 8, _hoisted_6)], 10, _hoisted_2);
        }), 128))]),
        _: 1
      })]), _createVNode(_Transition, {
        name: "confirm-fade"
      }, {
        default: _withCtx(() => [_unref(feedbackState).confirm ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "confirm-backdrop",
          role: "presentation",
          onKeydown: [_withKeys(_withModifiers(closeFromKeyboard, ["stop", "prevent"]), ["esc"]), _withKeys(trapConfirmFocus, ["tab"])],
          onMousedown: _withModifiers(closeFromBackdrop, ["self"])
        }, [_createElementVNode("section", {
          ref_key: "confirmCardRef",
          ref: confirmCardRef,
          tabindex: "-1",
          class: "confirm-card",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-labelledby": confirmTitleId,
          "aria-describedby": "global-confirm-description"
        }, [_createElementVNode("div", {
          class: _normalizeClass(["confirm-mark", _unref(feedbackState).confirm.tone])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(confirmIcon.value)))]),
          _: 1
        })], 2), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("h2", {
          id: confirmTitleId
        }, _toDisplayString(_unref(feedbackState).confirm.title), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(feedbackState).confirm.message), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
          ref_key: "cancelButtonRef",
          ref: cancelButtonRef,
          class: "cancel",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => _unref(feedback).resolveConfirm(false))
        }, _toDisplayString(_unref(feedbackState).confirm.cancelText), 513), _createElementVNode("button", {
          class: _normalizeClass(["confirm", _unref(feedbackState).confirm.tone]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = $event => _unref(feedback).resolveConfirm(true))
        }, _toDisplayString(_unref(feedbackState).confirm.confirmText), 3)])], 512)], 40, _hoisted_7)) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};